import { useContext } from 'react'
import MigrantsFooter from './components/MigrantsFooter'
import { AuthContext } from '../../Auth/AuthContext'
import MigrantsHeader from './components/MigrantsHeader'

const DashboardMigrantsContact = () => {
  //------------ Hooks ------------
  const { dispatch, user } = useContext(AuthContext)

  return (
    <div className="dashboard-migrants-contact">
      <div className="col-12">
        <MigrantsHeader user={user} dispatch={dispatch} />
      </div>
      <div className="col-12">
        <MigrantsFooter />
      </div>
    </div>
  )
}

export default DashboardMigrantsContact
